import { ITimeZoneDictionaryApi } from '@/types';
import { useRemoteDictionaryHelpers } from '@/stores/utils/useRemoteDictionaryHelpers';
import { TimeZoneItem } from '@/models/dictionary/timeZone';

export const useTimeZoneDictionary = defineStore('timeZoneDictionary', () => {
    const items = shallowRef<TimeZoneItem[]>([]);

    const { itemById, nameById } = useRemoteDictionaryHelpers(items);

    // actions
    function setData(data: ITimeZoneDictionaryApi[]) {
        console.time('set-timeZone-dictionary');
        items.value = data.map((item) => new TimeZoneItem(item));
        console.timeEnd('set-timeZone-dictionary');
    }

    return {
        items,
        itemById,
        nameById,
        setData,
    };
});
